import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Carousel } from "../Stack/Carousel.js";
// Bubbles per row at each breakpoint. Fewer per row means bigger bubbles.
// Full class names so Tailwind picks them up.
const bubbleSizeClasses = {
    large: "@2xl:[--visible-columns:4.25] @4xl:[--visible-columns:6]",
    small: "",
};
export function BubbleMenu({ children, className, as, carousel, size = "small", ...rest }) {
    const Component = as ?? "ul";
    if (carousel.config?.count > 6) {
        return (_jsx(Carousel, { as: Component, ...carousel, className: classNames(
            // The carousel's own column rules win over cvr-carousel-columns-overflow,
            // so hand it the bubble column count and drop its half-visible sibling.
            "cvr-carousel-columns-overflow [--cvr-stack-columns:var(--visible-columns)] [--cvr-stack-visible-sibling:0]", className), ...rest, children: children }));
    }
    return (_jsx(Component, { className: classNames("cvr-carousel-columns-overflow", bubbleSizeClasses[size], className), ...rest, children: children }));
}
